import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function chevronDown({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke="black"
      viewBox="0 0 13 11"
      width="13"
      height="11"
      className={className}
    >
      <path
        fill="none"
        d="M6.93301 10.25C6.74056 10.5833 6.25944 10.5833 6.06699 10.25L1.30385 2C1.1114 1.66667 1.35196 1.25 1.73686 1.25L11.2631 1.25C11.648 1.25 11.8886 1.66667 11.6962 2L6.93301 10.25Z"
      />
    </svg>
  );
}

export default chevronDown;
